import styled from 'styled-components'

import { colors } from '../../theme'

import { PeriodTableProps } from './index'

export const Dot = styled.span`
  display: inline-block;
  width: 1.5rem;
  height: 1.5rem;
  background-color: ${colors.greenSecondaryBis};
  border-radius: 1.5rem;
`

const basic: PeriodTableProps = {
  labels: {
    morningRowLabel: 'Matin',
    afternoonRowLabel: 'Après-midi',
    mondayLabel: 'L',
    tuesdayLabel: 'M',
    wednesdayLabel: 'M',
    thursdayLabel: 'J',
    fridayLabel: 'V',
    saturdayLabel: 'S',
    sundayLabel: 'D',
  },
  monday: {
    morning: <Dot />,
    afternoon: <Dot />,
  },
  tuesday: {
    morning: <Dot />,
    afternoon: <Dot />,
  },
  wednesday: {
    morning: <Dot />,
    afternoon: <Dot />,
  },
  thursday: {
    morning: <Dot />,
    afternoon: <Dot />,
  },
  friday: {
    morning: <Dot />,
    afternoon: <Dot />,
  },
  saturday: {
    morning: <Dot />,
    afternoon: <Dot />,
  },
  sunday: {
    morning: <Dot />,
    afternoon: <Dot />,
  },
}

const withGrid: PeriodTableProps = {
  ...basic,
  labels: {
    ...basic.labels,
    columnLabel: 'Jours',
  },
  withGrid: true,
}

export const periodTableMocks = {
  basic,
  withGrid,
}
